import { observer } from "mobx-react-lite";

import contentStore from "../stores/cms/contentStore";
import productStore from "../stores/product/productStore";

import AlertMessage from "./AlertMessage";
import TrackedAlert from "./TrackedAlert";

const TopBarWarnings = () => {
   const warnings = contentStore.getCurrentWarnings();

   const filteredWarnings = warnings.filter((c) => c.warningtype?.includes("Toppen av alle sider"));
   const showCachedDataWarning = !!productStore.cacheMetadata;
   const showCacheRecoveredAlert = productStore.showCacheRecoveredAlert;

   if (filteredWarnings.length === 0 && !showCachedDataWarning && !showCacheRecoveredAlert) {
      return null;
   }
   return (
      <aside className="print:hidden">
         {showCachedDataWarning && (
            <TrackedAlert
               fullWidth
               variant="warning"
               showCloseButton={false}
               className="justify-center px-0 [&>div>div>div>div>p]:mb-0 [&>div]:max-w-[--main-column-max-width] [&>div]:px-3 sm:[&>div]:px-4 md:[&>div]:px-12"
               title="Vi har for tiden utfordringer med å vise oppdaterte priser på TINE Handel"
               source="TopBarWarnings"
               tracking={{
                  context: "top_bar",
                  text: "cached_data_warning"
               }}
            >
               Du kan fortsatt sende inn ordre som vanlig, men priser og sortiment kan avvike noe. Endelig pris og bekreftet
               tilgjengelighet vises på faktura.
            </TrackedAlert>
         )}
         {showCacheRecoveredAlert && (
            <TrackedAlert
               fullWidth
               variant="information"
               showCloseButton
               onClose={productStore.dismissCacheRecoveredAlert}
               className="justify-center px-0 [&>div>div>div>div>p]:mb-0 [&>div]:max-w-[--main-column-max-width] [&>div]:px-3 sm:[&>div]:px-4 md:[&>div]:px-12"
               title="Priser er oppdatert"
               source="TopBarWarnings"
               tracking={{
                  context: "top_bar",
                  text: "cached_data_recovered_information"
               }}
            >
               Vi har igjen tilgang til oppdaterte priser og rabatter. Merk at noen varer kan ha fått ny pris.
            </TrackedAlert>
         )}
         {filteredWarnings.map((warning) => (
            <AlertMessage
               key={warning.internalName}
               warning={warning}
               className="md:[&>div]:px-12"
               source="TopBarWarnings"
               tracking={{ context: "top_bar", text: "cms_top_bar_warning" }}
            />
         ))}
      </aside>
   );
};

export default observer(TopBarWarnings);
